import setupWebComponents from 'shared/webcomponents'

setupWebComponents()
